import { render, staticRenderFns } from "./Advert2Section.vue?vue&type=template&id=34e8283e&scoped=true"
import script from "./Advert2Section.vue?vue&type=script&lang=js"
export * from "./Advert2Section.vue?vue&type=script&lang=js"
import style0 from "./Advert2Section.vue?vue&type=style&index=0&id=34e8283e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8283e",
  null
  
)

export default component.exports